import {createAction} from 'web-app/util/redux/famly-app-helpers';

import {type CreateEmployeeFormData} from './new-employee-form/types';

const domain = 'NEW_EMPLOYEE';

export const {
    action: createNewEmployee,
    success: createNewEmployeeSuccess,
    failed: createNewEmployeeFailed,
} = createAction(
    `${domain}/CREATE_EMPLOYEE`,
    (institutionId: string, formData: CreateEmployeeFormData) => ({
        institutionId,
        formData,
    }),
    () => ({}),
    (error: Error) => ({error}),
);
